<script lang="ts" setup>
import type { PropType } from 'vue'

defineProps({
  label: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    required: false,
    default: 'quiz-button'
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isFetching: {
    type: Boolean,
    default: false,
  },
  variant: {
    type: String,
    default: 'primary',
    validator: (value: string) => ['primary', 'secondary'].includes(value)
  },
  type: {
    type: String as PropType<'button' | 'submit' | 'reset'>,
    default: 'submit',
    validator: (value: string) => ['button', 'submit', 'reset'].includes(value)
  },
})
const emit = defineEmits(['click'])
</script>

<template>
  <button @click="emit('click')"
          class="w-full py-2 rounded-md transition cursor-pointer disabled:cursor-not-allowed flex items-center gap-2 justify-center"
          :class="{
            'bg-[#FFDE02] disabled:bg-[#FFDE02]/60 disabled:text-gray-900': variant === 'primary',
            'bg-green-500 disabled:bg-green-500/60 text-white': variant === 'secondary',
          }"
          :id="id"
          :disabled="disabled"
          :type="type"
  >
    <svg v-if="isFetching" class="mr-3 -ml-1 size-5 animate-spin"
         xmlns="http://www.w3.org/2000/svg"
         fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
              stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
      </path>
    </svg>
    <span>
      {{ label }}
    </span>
  </button>
</template>
